import { getAssetPath, Env } from '@stencil/core';
import { NAMESPACE } from './constants';

export let API_BASE_URL: string = Env.DEV_BASE_URL ?? '';

export async function loadConfig() {
  if (window.location.hostname === 'localhost') {
    return;
  }

  const scriptElement = document.querySelector(`script[src*="${NAMESPACE}"]`);
  if (scriptElement) {
    const scriptSrc = scriptElement.getAttribute('src');
    if (scriptSrc) {
      const url = new URL(scriptSrc, window.location.href);
      API_BASE_URL = `${url.protocol}//${url.host}`;
    }
  } else {
    try {
      const assetPath = getAssetPath('.');
      const url = new URL(assetPath, window.location.href);
      API_BASE_URL = `${url.protocol}//${url.host}`;
    } catch (error) {
      console.error('Failed to determine API base URL:', error);
    }
  }
}
